import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Plus } from "lucide-react";
import AdminShell from "@/web/components/admin/admin-shell";
import { Button } from "@/web/components/ui/button";
import { Input } from "@/web/components/ui/input";
import { Label } from "@/web/components/ui/label";
import { Textarea } from "@/web/components/ui/textarea";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/web/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/web/components/ui/dialog";
import { PRODUCTS } from "@/data/products";

export default function AdminProducts() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Helmet><title>Products · Admin | Cool Wave</title></Helmet>
      <AdminShell>
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold">All products</h2>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button><Plus className="h-4 w-4" /> New product</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>New product</DialogTitle>
                <DialogDescription>CRUD wiring is stubbed — backend hooks added in Phase 2 activation.</DialogDescription>
              </DialogHeader>
              <div className="grid gap-4">
                <div><Label>Name</Label><Input className="mt-1.5" /></div>
                <div><Label>Slug</Label><Input className="mt-1.5" /></div>
                <div><Label>Category</Label><Input className="mt-1.5" /></div>
                <div><Label>Price (NZD)</Label><Input type="number" className="mt-1.5" /></div>
                <div><Label>Description</Label><Textarea className="mt-1.5" /></div>
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
                <Button disabled>Save (coming soon)</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
        <div className="rounded-md border border-border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Brand</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>Stock</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {PRODUCTS.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center text-sm text-body">No products yet.</TableCell>
                </TableRow>
              ) : (
                PRODUCTS.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell>{p.name}</TableCell>
                    <TableCell>{p.category}</TableCell>
                    <TableCell>{p.brand}</TableCell>
                    <TableCell>${(p.priceNzdCents / 100).toFixed(2)}</TableCell>
                    <TableCell>{p.stockCount ?? 0}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </AdminShell>
    </>
  );
}
